module.exports = __webpack_public_path__ + "img/key.d9ecf753.svg";